/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_V2_Documents_With_NotesInputs */

const en_notes_v2_documents_with_notes = /** @type {(inputs: Notes_V2_Documents_With_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents with notes`)
};

const es_notes_v2_documents_with_notes = /** @type {(inputs: Notes_V2_Documents_With_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos con notas`)
};

/**
* | output |
* | --- |
* | "Documents with notes" |
*
* @param {Notes_V2_Documents_With_NotesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const notes_v2_documents_with_notes = /** @type {((inputs?: Notes_V2_Documents_With_NotesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_V2_Documents_With_NotesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_notes_v2_documents_with_notes(inputs)
	return en_notes_v2_documents_with_notes(inputs)
});